import { CalendarEventFormFields, ExternalCalendarEvent } from '@griply/types';
import { addDays, addMilliseconds } from 'date-fns';

import { toExternalEventBoundary } from './to-external-event-boundary';

export type EventFormOptimisticEvent = Pick<
  ExternalCalendarEvent,
  'title' | 'start' | 'end'
>;

// What the grid should show the instant the popup closes, before the provider round-trip
// and refetch land. Only the fields the grid actually renders — everything else on the
// cached event is left untouched.
export const buildEventFormOptimisticEvent = (
  fields: CalendarEventFormFields,
): EventFormOptimisticEvent => {
  if (fields.allDay) {
    return {
      title: fields.title,
      start: toExternalEventBoundary(true, fields.startDate),
      // the form holds an inclusive end; the grid expects an exclusive one
      end: toExternalEventBoundary(true, addDays(fields.endDate, 1)),
    };
  }

  return {
    title: fields.title,
    start: toExternalEventBoundary(
      false,
      addMilliseconds(fields.startDate, fields.startTime ?? 0),
    ),
    end: toExternalEventBoundary(
      false,
      addMilliseconds(fields.endDate, fields.endTime ?? 0),
    ),
  };
};
